export const mapDataForUpdate = (data) => {
  return {
    // overview
    recommendApproval: data.recommendApproval,
    recommendDenial: data.recommendDenial,
    inReview: data.inReview,
    automasterId: data.automasterId,
    applicationType: data.applicationType,
    loanType: data.loanType,
    applicationDate: data.applicationDate || null,
    previousCredit: data.previousCredit,
    bankruptcy: data.bankruptcy,
    bankruptcyInfo: data.bankruptcyInfo,
    lawsuit: data.lawsuit,
    lawsuitInfo: data.lawsuitInfo,
    finished: data.finished,
    ctr: data.ctr,
    ctl: data.ctl,
    cts: data.cts,
    cps: data.cps,
    cig: data.cig,
    cfs: data.cfs,
    cls: data.cls,
    csb: data.csb,
    driverName: data.driverName,
    driverLicenseNumber: data.driverLicenseNumber,
    driverLicenseStateId: data.driverLicenseStateId,
    driverLicenseType: data.driverLicenseType,
    driverLicenseExpireDate: data.driverLicenseExpireDate || null,
    driverYearsOfExperience: data.driverYearsOfExperience,
    // business
    name: data.name,
    description: data.description,
    numberOfTrucks: data.numberOfTrucks,
    numberOfTrailers: data.numberOfTrailers,
    federalTaxId: data.federalTaxId,
    dateEstablished: data.dateEstablished || null,
    street: data.street,
    stateId: data.stateId,
    city: data.city,
    zip: data.zip,
    businessPhone: data.businessPhone,
    primaryContactName: data.primaryContactName,
    fax: data.fax,
    contactPhone: data.contactPhone,
    annualGrossSales: data.annualGrossSales,
    businessAssets: data.businessAssets,
    checkingAccountBalance: data.checkingAccountBalance,
    mcNumber: data.mcNumber,
    businessLiabilities: data.businessLiabilities,
    averageMonthlyBalance: data.averageMonthlyBalance,

    // nada values
    eqVin: data.eqVin,
    eqStockNumber: data.eqStockNumber,
    eqCondition: data.eqCondition,
    eqYear: data.eqYear,
    eqMake: data.eqMake,
    eqModel: data.eqModel,
    eqActualMileage: data.eqActualMileage,
    eqSalePrice: data.eqSalePrice,
    eqWholesaleValue: data.eqWholesaleValue,
    eqLoanValue: data.eqLoanValue,
    eqRetailValue: data.eqRetailValue,

    // deal summary
    eqPurchasePrice: data.eqPurchasePrice,
    eqTotalInvoice: data.eqTotalInvoice,
    eqProposedDownPayment: data.eqProposedDownPayment,
    eqProposedTerm: data.eqProposedTerm,
    eqEstimatedInterestRate: data.eqEstimatedInterestRate,
    eqTotalFinancedAmount: data.eqTotalFinancedAmount,
    eqEstimatedMonthlyPayment: data.eqEstimatedMonthlyPayment,
    eqCrmPurchasePrice: data.eqCrmPurchasePrice,
    eqCrmTotalInvoice: data.eqCrmTotalInvoice,
    eqCrmProposedDownPayment: data.eqCrmProposedDownPayment,
    eqCrmProposedTerm: data.eqCrmProposedTerm,
    eqCrmEstimatedInterestRate: data.eqCrmEstimatedInterestRate,
    eqCrmTotalFinancedAmount: data.eqCrmTotalFinancedAmount,
    eqCrmEstimatedMonthlyPayment: data.eqCrmEstimatedMonthlyPayment,

    applicant: {
      id: data.applicant.id,
      firstName: data.applicant.firstName,
      middleName: data.applicant.middleName,
      lastName: data.applicant.lastName,
      mcNumber: data.applicant.mcNumber,
      mortgage: data.applicant.mortgage,
      licenseNumber: data.applicant.licenseNumber,
      maritalStatus: data.applicant.maritalStatus,
      dependents: data.applicant.dependents,
      dob: data.applicant.dob || null,
      ssn: data.applicant.ssn,
      email: data.applicant.email,
      mobilePhone: data.applicant.mobilePhone,
      homePhone: data.applicant.homePhone,
      yearsAsDriver: data.applicant.yearsAsDriver,
      yearsAsOwner: data.applicant.yearsAsOwner,
      currentEmployment: {
        id: data.applicant.currentEmployment.id,
        name: data.applicant.currentEmployment.name,
        position: data.applicant.currentEmployment.position,
        address: data.applicant.currentEmployment.address,
        phoneNumber: data.applicant.currentEmployment.phoneNumber,
        workingSince: data.applicant.currentEmployment.workingSince,
        monthlyGrossIncome: data.applicant.currentEmployment.monthlyGrossIncome,
        otherIncomeSource: data.applicant.currentEmployment.otherIncomeSource,
        otherIncomeAmount: data.applicant.currentEmployment.otherIncomeAmount,
        incomeReduced: data.applicant.currentEmployment.incomeReduced,
        whyReduced: data.applicant.currentEmployment.whyReduced,
      },
    },
    coApplicant: {
      id: data.coApplicant.id,
      firstName: data.coApplicant.firstName,
      middleName: data.coApplicant.middleName,
      lastName: data.coApplicant.lastName,
      dob: data.coApplicant.dob || null,
      ssn: data.coApplicant.ssn,
      mobilePhone: data.coApplicant.mobilePhone,
      homePhone: data.coApplicant.homePhone,
      email: data.coApplicant.email,
      currentEmployment: {
        id: data.coApplicant.currentEmployment.id,
        name: data.coApplicant.currentEmployment.name,
        position: data.coApplicant.currentEmployment.position,
        address: data.coApplicant.currentEmployment.address,
        phoneNumber: data.coApplicant.currentEmployment.phoneNumber,
        workingSince: data.coApplicant.currentEmployment.workingSince,
        monthlyGrossIncome: data.coApplicant.currentEmployment.monthlyGrossIncome,
        otherIncomeSource: data.coApplicant.currentEmployment.otherIncomeSource,
        otherIncomeAmount: data.coApplicant.currentEmployment.otherIncomeAmount,
        incomeReduced: data.coApplicant.currentEmployment.incomeReduced,
        whyReduced: data.coApplicant.currentEmployment.whyReduced,
      },
    },
  }
}
